<template>
  <header class="header">
    <div class="overlay" ref="overlay" :class="{ active: isMobileMenuOpen }" @click="closeNav"></div>
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/images/logo.png" alt="腾智一体化ERP">
          </router-link>
        </div>
        <nav class="main-nav" :class="{ active: isMobileMenuOpen }">
          <ul class="nav-list">
            <li class="nav-item" :class="{ active: $route.path === '/' }">
              <router-link to="/" class="nav-link">首页</router-link>
            </li>
            <li class="nav-item" :class="{ active: $route.path === '/about' }">
              <router-link to="/about" class="nav-link">公司介绍</router-link>
            </li>
<li class="nav-item has-dropdown" :class="{ active: $route.path === '/pro' }">
  <router-link to="/pro" class="nav-link" @click="toggleDropdown">产品中心</router-link>
  <div class="dropdown-menu product-menu">
    <div class="dropdown-content">
      <div class="menu-section">
        <ul>
          <li><a href="#erp">一体化ERP</a></li>
          <li><a href="#mes">数字车间MES</a></li>
          <li><a href="#marketing">物联网</a></li>
          <li><a href="#mobile">移动办公</a></li>
          <li><a href="#manufacturing">智能制造</a></li>
        </ul>
      </div>
    </div>
  </div>
</li>
            <li class="nav-item" :class="{ active: $route.path === '/function' }">
              <router-link to="/function" class="nav-link">产品功能</router-link>
            </li>
            <li class="nav-item" :class="{ active: $route.path.startsWith('/zskt') }">
              <router-link to="/zskt" class="nav-link">知识课堂</router-link>
            </li>
            <li class="nav-item" :class="{ active: $route.path === '/list' || $route.path.startsWith('/show') }">
              <router-link to="/list" class="nav-link">企业动态</router-link>
            </li>
            <li class="nav-item" :class="{ active: $route.path === '/contact' }">
              <router-link to="/contact" class="nav-link">联系我们</router-link>
            </li>
            <li class="nav-item">
              <a href="https://sdtz.guanjd.com/#/" class="nav-link try-btn">申请试用</a>
            </li>
          </ul>
        </nav>
        <button class="mobile-nav-toggle" ref="mobileNavToggle" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }" aria-label="切换导航菜单" :aria-expanded="isMobileMenuOpen.toString()" aria-controls="main-nav">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
methods: {
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    document.body.classList.toggle('nav-active');
    if (this.$refs.mobileNavToggle) {
      this.$refs.mobileNavToggle.setAttribute('aria-expanded', this.isMobileMenuOpen.toString());
    }
    
    if (this.isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  },
  
  toggleDropdown(event) {
    if (window.innerWidth <= 992) {
      const dropdownItem = event.target.closest('.has-dropdown');
      if (dropdownItem) {
        dropdownItem.classList.toggle('active');
        
        // 关闭其他打开的下拉菜单
        const otherDropdowns = this.$el.querySelectorAll('.has-dropdown.active');
        otherDropdowns.forEach(item => {
          if (item !== dropdownItem) {
            item.classList.remove('active');
          }
        });
      }
    }
  },

  closeNav() {
    this.isMobileMenuOpen = false;
    document.body.classList.remove('nav-active');
    if (this.$refs.mobileNavToggle) {
      this.$refs.mobileNavToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }
},
  mounted() {
    // 确保页面初始化时可以正常滚动
    document.body.style.overflow = '';
    
    // 点击遮罩层关闭菜单
    if (this.$refs.overlay) {
      this.$refs.overlay.addEventListener('click', this.closeNav);
    }
    
    // 点击导航链接后关闭菜单
    const navLinks = this.$el.querySelectorAll('.nav-link:not(.has-dropdown .nav-link)');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (window.innerWidth <= 768) {
          this.closeNav();
        }
      });
    });

    // 监听路由变化，关闭移动端菜单
    this.$router.beforeEach((to, from, next) => {
      if (this.isMobileMenuOpen) {
        this.closeNav();
      }
      next();
    });

    // 窗口大小改变时重置导航状态
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        this.closeNav();
        this.$el.querySelectorAll('.has-dropdown').forEach(item => item.classList.remove('active'));
      }
    });
  },
  
  beforeUnmount() {
    // 组件卸载时确保恢复 body 滚动
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
:root {
  --primary-color: #009b7b;
  --secondary-color: #006d56;
  --text-color: #2c3e50;
  --white: #ffffff;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.container {
  max-width: 1450px;
  margin: 0 auto;
  padding: 0 15px;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo {
  flex: 0 0 180px;
}

.logo img {
  max-height: 50px;
  width: auto;
}

.main-nav {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  margin: 0 5px;
}

.nav-link {
  display: block;
  padding: 10px 20px;
  color: var(--text-color);
  text-decoration: none;
  font-size: 20px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: var(--primary-color);
}

.nav-item.active .nav-link {
  color: var(--primary-color);
  font-weight: 500;
  position: relative;
}

.nav-item.active .nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 3px;
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--primary-color) 100%);
  border-radius: 2px;
  animation: activeSlideIn 0.3s ease forwards;
}

@keyframes activeSlideIn {
  from {
    transform: scaleX(0);
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    opacity: 1;
  }
}

.try-btn {
  background: var(--primary-color);
  color: var(--white) !important;
  border-radius: 8px;
  padding: 10px 25px !important;
  margin-left: 15px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 155, 123, 0.15);
}

.try-btn:hover {
  background: var(--secondary-color);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 155, 123, 0.2);
}

.mobile-nav-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  z-index: 1001;
}

.mobile-nav-toggle span {
  display: block;
  width: 28px;
  height: 3px;
  margin: 5px 0;
  background: #333;
  transition: all 0.3s;
}

/* 下拉菜单 */
.has-dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  min-width: 200px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s;
  z-index: 100;
  padding: 15px 0;
  border-radius: 5px;
}

.has-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-content {
  padding: 0 15px;
}

.menu-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-section li {
  margin: 10px 0;
}

.menu-section a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
  transition: color 0.3s;
  display: block;
}

.menu-section a:hover {
  color: #009b7b;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 998;
  display: none;
}

.overlay.active {
  display: block;
}

/* 移动菜单激活状态 */
.mobile-nav-toggle.active span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.mobile-nav-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-nav-toggle.active span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}
@media (max-width: 992px) {
  .mobile-nav-toggle {
    display: block;
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
    z-index: 1001;
  }

  .mobile-nav-toggle span {
    display: block;
    width: 30px;
    height: 3px;
    margin: 6px 0;
    background: var(--text-color);
    transition: all 0.3s ease;
  }

  .mobile-nav-toggle.active span:nth-child(1) {
    transform: translateY(9px) rotate(45deg);
  }

  .mobile-nav-toggle.active span:nth-child(2) {
    opacity: 0;
  }

  .mobile-nav-toggle.active span:nth-child(3) {
    transform: translateY(-9px) rotate(-45deg);
  }

.main-nav {
    position: fixed;
    top: 80px;
    right: -300px;
    width: 80%;
    max-width: 400px;
    height: calc(100vh - 80px);
    background: #ffffff;
    z-index: 1000;
    transition: transform 0.3s ease-in-out;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 4px 4px;
    overflow-y: auto;
  }

  .main-nav.active {
    transform: translateX(0);
    right: 0;
  }

  .nav-list {
    flex-direction: column;
    width: 100%;
  }

  .nav-item {
    margin: 0;
    width: 100%;
  }

  .nav-link {
    padding: 15px 10px;
    border-bottom: 1px solid #f0f0f0;
    width: 100%;
    font-size: 16px;
  }

  .has-dropdown .dropdown-menu {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    box-shadow: none;
    padding: 5px 0 5px 20px;
    background: #f8f9fa;
    margin-top: 5px;
    border-radius: 0;
    display: none;
  }

  .has-dropdown.active .dropdown-menu {
    display: block;
  }

  .menu-section ul {
    display: block;
  }

  .menu-section li {
    margin: 5px 0;
  }

  .menu-section a {
    padding: 8px 0;
    font-size: 14px;
  }

  .try-btn {
    margin-top: 15px;
    text-align: center;
  }

  .overlay {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(26, 115, 232, 0.7), rgba(0, 155, 123, 0.7));
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  }

  .overlay.active {
    opacity: 1;
    visibility: visible;
  }
}
</style>